import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Link } from 'react-router-dom';
import DisplayAssignment from './DisplayAssignment';
import { Haldor__Block, addBlockTranslations } from '@haldor/ui';
import './_AssignmentBlock.scss';
var AssignmentBlock = /*#__PURE__*/function (_Haldor__Block) {
  function AssignmentBlock(_props) {
    var _this;
    _classCallCheck(this, AssignmentBlock);
    _this = _callSuper(this, AssignmentBlock, [_props]);
    _defineProperty(_this, "consume", function (props) {
      return /*#__PURE__*/React.createElement("div", {
        className: "block--assignment-block consume"
      }, props.resources != null && props.resources.length > 0 ? props.resources.map(function (resource) {
        return /*#__PURE__*/React.createElement(Link, {
          className: "assignment-resource",
          to: "/assignment/".concat(resource.id),
          key: resource.id
        }, /*#__PURE__*/React.createElement(DisplayAssignment, {
          assignment: resource
        }));
      }) : null);
    });
    _defineProperty(_this, "edit", function (props) {
      return null;
    });
    _this.name = 'Haldor.Blocks.Assignment';
    _this.order = 47;
    _this.svgIcon = function () {
      return /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w2.org/2000/svg",
        viewBox: "0 0 50 50",
        dangerouslySetInnerHTML: {
          __html: "\n\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t<style>.icon-block-assignment-1{fill:#c8c9c8;}</style>\n\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t<path class=\"icon-block-assignment-1\" d=\"M36.85,7.23H13.15a5.92,5.92,0,0,0-5.92,5.92v23.7a5.92,5.92,0,0,0,5.92,5.92h23.7a5.92,5.92,0,0,0,5.92-5.92V13.15A5.92,5.92,0,0,0,36.85,7.23ZM13.19,38.78a2,2,0,0,1-2-2l0-3.1V13.15a2,2,0,0,1,2-2h23.7a2,2,0,0,1,2,2V34.87l0,1.94a2,2,0,0,1-2,2l-22.63,0Z\"/>\n\t\t\t\t\t\t<path class=\"icon-block-assignment-1\" d=\"M22.78,33.31a2,2,0,0,1-1.44-.63L14.8,25.46a2,2,0,0,1,2.88-2.71l5.08,5.68,9.46-11a2,2,0,0,1,2.78-.3,2,2,0,0,1,.3,2.77l-.15.18L24.24,32.66a2,2,0,0,1-1.44.65Z\"/>\n\t\t\t\t\t"
        }
      });
    };
    addBlockTranslations('sv-se', [{
      output: 'Uppgifter',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('en-us', [{
      output: 'Assignments',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('nb-no', [{
      output: 'Oppgaver',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('da-dk', [{
      output: 'Opgaver',
      id: 'Haldor.Blocks.Assignment'
    }]);
    addBlockTranslations('uk', [{
      output: 'Задачі',
      id: 'Haldor.Blocks.Assignment'
    }]);
    _this.registerResourceType('haldor.assignment.block.assignment', {
      id: 'number',
      title: 'string',
      assignmentType: 'string',
      description: 'string?',
      dueDate: 'string',
      groupEnabled: 'boolean',
      publishedAssessments: 'number',
      sectionId: 'string',
      startDate: 'string',
      status: 'string',
      submittedTasks: 'number',
      totalTasks: 'number'
    });
    return _this;
  }
  _inherits(AssignmentBlock, _Haldor__Block);
  return _createClass(AssignmentBlock);
}(Haldor__Block);
export default AssignmentBlock;